const platforms = [
  {
    title: "ChatGPT",
    description:
      "An AI language model developed by OpenAI, capable of generating human-like text based on input prompts.",
    image:
      "https://tse3.mm.bing.net/th?id=OIP.-lMj5mmGa5ziPdlbc_JMGgHaEl&pid=Api&P=0&h=180",
    link: "https://openai.com/chatgpt",
  },
  {
    title: "DALL-E",
    description:
      "A neural network-based image generation tool by OpenAI that creates images from textual descriptions.",
    image: "https://www.eyerys.com/sites/default/files/open-ai-dalle.png",
    link: "https://openai.com/dall-e",
  },
  {
    title: "IBM Watson",
    description:
      "IBM's suite of enterprise-ready AI services, applications, and tooling.",
    image:
      "http://p7.itc.cn/q_70/images03/20201229/880ecbdb80b8408182da875019a43f93.png",
    link: "https://www.ibm.com/watson",
  },
  {
    title: "Snyk",
    description:
      "An AI-powered security tool that helps developers find and fix vulnerabilities in their code and open source dependencies.",
    image:
      "https://cdn.prod.website-files.com/644238b1cf656a0846763003/6489b97039eaf708d4df4cfd_SnykCover.png",
    link: "https://snyk.io/",
  },
  {
    title: "Hugging Face Transformers",
    description:
      "A library for state-of-the-art NLP, providing pre-trained models and tools to use them.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROmjEBevfH7YP-AnIbZrxkvnBfXRsAP5EvhQ&s",
    link: "https://huggingface.co/transformers",
  },
  {
    title: "Google Cloud AI",
    description:
      "Google Cloud's AI tools and services for building, deploying machine learning models.",
    image:
      "https://cloud.google.com/images/social-icon-google-cloud-1200-630.png",
    link: "https://cloud.google.com/products/ai",
  },
  {
    title: "Microsoft Azure AI",
    description:
      "Azure AI services and tools for building AI solutions using machine learning and deep learning.",
    image: "https://logowik.com/content/uploads/images/microsoft-azure7662.jpg",
    link: "https://azure.microsoft.com/en-us/solutions/ai/",
  },
  {
    title: "Caffe",
    description:
      "A deep learning framework made with expression, speed, and modularity in mind.",
    image:
      "https://tse3.mm.bing.net/th?id=OIP.0bsZvCL4FvDEhc21wFRn1AHaE8&pid=Api&P=0&h=180",
    link: "https://caffe.berkeleyvision.org/",
  },
  {
    title: "Apache Mahout",
    description:
      "A scalable machine learning library that enables developers to work on large datasets.",
    image:
      "https://tse3.mm.bing.net/th?id=OIP.wmQbtGFYT7xcH2kjaB-1RgHaCp&pid=Api&P=0&h=180",
    link: "https://mahout.apache.org/",
  },
  {
    title: "RapidMiner",
    description:
      "A data science platform that provides an environment for machine learning and deep learning",
    image:
      "https://www.topbots.com/wp-content/uploads/2020/07/rapidminer-logo_1600px_web.jpg",
    link: "https://rapidminer.com/",
  },
  {
    title: "KNIME",
    description:
      "A free and open-source data analytics, reporting, and integration platform.",
    image: "https://hub.knime.com/og-image-256.png",
    link: "https://www.knime.com/",
  },
  {
    title: "GitHub Copilot",
    description:
      "An AI-powered code completion tool developed by GitHub in collaboration with OpenAI, which helps developers write code faster by suggesting entire lines or blocks of code.",
    image:
      "https://www.it-labs.com/wp-content/uploads/2023/05/GitHub-Copilot-logo-1040x650-1.png",
    link: "https://github.com/features/copilot",
  },
  {
    title: "TabNine",
    description:
      "An AI-powered code completion tool that enhances code writing by predicting and suggesting the next code segments based on context.",
    image:
      "https://pbs.twimg.com/profile_images/1785337827787726848/6UeBPcDU_400x400.png",
    link: "https://www.tabnine.com/",
  },
  {
    title: "Kite",
    description:
      "An AI-powered code completion tool that helps developers by providing intelligent code suggestions and documentation.",
    image: "https://avatars.githubusercontent.com/u/7321919?s=280&v=4",
    link: "https://www.kite.com/",
  },
  {
    title: "DeepCode",
    description:
      "An AI-driven code review tool that automatically analyzes code to identify potential bugs, security vulnerabilities, and other issues.",
    image:
      "https://cdn.prod.website-files.com/644238b1cf656a0846763003/6489b989851a55ebceb3ca78_SnykIcon.png",
    link: "https://www.deepcode.ai/",
  },
  {
    title: "Sourcery",
    description:
      "An AI-powered code improvement tool that automatically suggests and applies refactoring changes to Python code.",
    image: "https://sourcery.ai/sourcery-social.png",
    link: "https://sourcery.ai/",
  },
];

export default platforms;
